import React from 'react';
import { RichText } from '@graphcms/rich-text-react-renderer';
import { Col, Divider, Row } from 'antd';
import styled from 'styled-components';
import CustomModal from '../../common-components/CustomModal';
import useStore from '../../hooks/useStore';
import {
  GreenLinkText,
  H7CamptonSemiBold22,
  H8CamptonSemiBold18,
  H8CamptonSemiBold19,
  SmallGrey12
} from '../../layout/globalFonts';
import ContentStore from '../../stores/ContentStore';
import ModalStore from '../../stores/ModalStore';

export interface LicensePlateAlreadyRegisteredModalProps {
  licensePlate: string;
  onConfirmation: () => void;
}

const StyledDivider = styled(Divider)`
  height: 1px;
  background-color: #dedede;
`;

const LicensePlateAlreadyRegisteredModal: React.FC<LicensePlateAlreadyRegisteredModalProps> = ({
  licensePlate,
  onConfirmation
}) => {
  const modalStore = useStore(ModalStore) as ModalStore;
  const { cmsStore } = useStore(ContentStore) as ContentStore;

  return (
    <CustomModal
      header={cmsStore.getContent('licenseplateAlreadyRegisteredModalTop')?.content!}
      primaryButtonText={cmsStore.getContent('TryAgain')?.content}
      closable
      onPrimaryButtonClick={() => {
        if (onConfirmation) {
          onConfirmation();
        }
        modalStore.closeModal();
      }}
    >
      <Col>
        <Row justify="center" style={{ marginTop: '10px' }}>
          <H8CamptonSemiBold18>
            {cmsStore.getContent('licenseplateAlreadyRegisteredModalTop')?.subText!}
          </H8CamptonSemiBold18>
        </Row>
        <Row justify="center">
          <SmallGrey12>{cmsStore.getContent('licensePlate')?.content}</SmallGrey12>
        </Row>
        <Row justify="center">
          <H7CamptonSemiBold22>{licensePlate}</H7CamptonSemiBold22>
        </Row>
        <StyledDivider style={{ margin: '20px 0px' }} />
        <Row>{cmsStore.getContent('LicensePlateAlreadyRegisteredModalFirstContent')?.content}</Row>
        <Row justify="center" style={{ marginTop: '20px' }}>
          <H8CamptonSemiBold19>
            {cmsStore.getContent('LicensePlateAlreadyRegisteredIsMyCar')?.content}
          </H8CamptonSemiBold19>
        </Row>
        <Row>{cmsStore.getContent('LicensePlateAlreadyRegisteredIsMyCar')?.subText}</Row>
        <Row justify="center" style={{ margin: '15px 0px 20px 0px' }}>
          <GreenLinkText>
            <RichText
              content={cmsStore.getContent('ContactCustomerServiceLink')?.richContent?.raw ?? []}
              renderers={{
                p: ({ children }) => <p style={{ marginBottom: '0px' }}>{children}</p>
              }}
            />
          </GreenLinkText>
        </Row>
        <Row justify="center">
          <H8CamptonSemiBold19>
            {cmsStore.getContent('LicensePlateAlreadyRegisteredTypo')?.content}
          </H8CamptonSemiBold19>
        </Row>
        <Row style={{ marginBottom: '40px' }}>
          {cmsStore.getContent('LicensePlateAlreadyRegisteredTypo')?.subText}
        </Row>
      </Col>
    </CustomModal>
  );
};

export default LicensePlateAlreadyRegisteredModal;
